import React from 'react';
import './LocationSchedule.less';

export const LocationSchedule = ({text}) => {
	return <span className="location-schedule">{text}</span>
}
